import React from 'react'
import { connect } from 'react-redux'
import { branch, compose, renderComponent } from 'recompose'
import { sessionActions, sessionSelectors } from './redux'
import sessionMenuItemLifecycle from './SessionMenuItemLifecycle'
import SessionMenuItem from './SessionMenuItem'
import Loading from '../../components/Loading'
import {push} from "connected-react-router";
import {opticianActions, opticianSelectors} from "../optician/redux";
import {careUnitActions, careUnitSelectors} from "../careUnit/redux";

const mapStateToProps = (state) => ({
    loggedInUser: sessionSelectors.loggedInUser(state),
    roles: sessionSelectors.roles(state),
    organizationName: sessionSelectors.organizationName(state),
    expiresUTC: sessionSelectors.expiresUTC(state),
    isLoggingOut: sessionSelectors.loggingOut(state),
    opticianProfileDialogOpen: opticianSelectors.profileDialogOpen(state),
    careUnitProfileDialogOpen: careUnitSelectors.profileDialogOpen(state),
    loginDialogOpen: sessionSelectors.loginDialogOpen(state)
});

const mapDispatchToProps = (dispatch) => ({
    onLogInClicked: (username) => dispatch(sessionActions.showLoginDialog()),
    onLogOutClicked: () => dispatch(sessionActions.logOut()),
    onChangePasswordClicked: () => dispatch(push("/bytlosenord")),
    onUpdateProfileClicked: (role) => {
        switch(role) {
            case 'CARE_UNIT':
                dispatch(careUnitActions.openProfileDialog())
                break;
            case 'OPTICIAN':
                dispatch(opticianActions.openProfileDialog())
                break;
            default:
                // dispatch nothing
                break;
        }
    },
    onSessionInitialized: (user, roles) => dispatch(sessionActions.sessionInitialized(user, roles)),
});

export default compose (
    connect(mapStateToProps, mapDispatchToProps),
    sessionMenuItemLifecycle,
    branch(({isLoggingOut}) => isLoggingOut,
        renderComponent(({loggedInUser})=><Loading title={'Loggar ut ' + loggedInUser + '...'}/>)
    )
)(SessionMenuItem)